var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group relative"},[_vm._t("default"),_c('span',{staticClass:"absolute z-10 bottom-full opacity-0 pointer-events-none rounded bg-blue-400 text-white whitespace-no-wrap p-2 group-hover:opacity-100 transition-opacity duration-200 group-hover:delay-200",class:{
      'left-1/2 rounded-bl-none': _vm.side === 'right',
      'right-1/2 rounded-br-none': _vm.side === 'left',
    }},[_vm._v(" "+_vm._s(_vm.text)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }